<template>
    <div>
        <common-table :table-columns="tableColumns" :url="url" :operate="[]" :form-fields="formFields" :permission="permission" :searchs="searchs" ref="table"/>
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "RaffleRules",
        components: {CommonTable},
        data() {
            return {
              rechargeVisible: false,
              rechargeForm: {
                agentId: '',
                username: '',
                amount: '',
                expound: '',
                activityName:''
              },
              domainTitle: '',
              domainVisible: false,
              domainForm: {
                agentId: '',
                domain: '',
                activityName:'',
              },
              domains: [],
              domainIds: [],
              agent: {},

              resetPwdVisible: false,
              resetPwdForm: {
                id: '',
                username: '',
                password: '',
                googleCode: ''
              },

              topAgents: null,
              agentParentForm: {
                id: '',
                parentId: '',
                username: '',
              },
              agentParentVisible: false,
                searchs:[
                    {
                        name: 'agentId',
                        placeholder: '代理',
                        type: 'select',
                        selectUrl: '/agent/getAll',
                        selectData: [],
                    },
                ],
                permission:{
                    add: 'raffleRules:add',
                    update: 'raffleRules:update',
                    delete: 'raffleRules:delete',
                    deleteBatch: 'raffleRules:deleteBatch'
                },
                url: {
                    get: '/raffleRules/listByCondition',
                    add: '/raffleRules/add',
                    update: '/raffleRules/update',
                    delete: '/raffleRules/delete',
                    delete_batch: '/raffleRules/deleteBatch'
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '75',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                }, {
                  field: 'activityName',
                  label: '活动名称',
                  show: true,
                  width: '',
                },  {
                    field: 'minRechargerAmount',
                    label: '最低充值',
                    show: true,
                }, {
                    field: 'maxRechargerAmount',
                    label: '最高充值',
                    show: true,
                },  {
                  field: 'minWinningAmount',
                  label: '最低奖励',
                  show: true,
                }, {
                  field: 'maxWinningAmount',
                  label: '最高奖励',
                  show: true,
                }, {
                  field: 'number',
                  label: '抽奖次数',
                  show: true,
                }, {
                  field: 'sort',
                  label: '排序',
                  show: true,
                }],
                formFields: {
                    addTitle: '添加活动',
                    updateTitle: '修改活动',
                    labelWidth: '90px',
                    model: [{
                        field: 'agentId',
                        label: '代理：',
                        type: 'select',
                        placeholder: '请选择代理',
                        rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
                        selectUrl: '/agent/getAll',
                        selectData: [],
                        add: true,
                        update: true,
                        filterable: true,
                    }, {
                      field: 'activityName',
                      label: '活动名称',
                      type: 'input',
                      placeholder: '活动名称',
                      rules: [{message: '请输入活动名称', trigger: 'blur', required: true}],
                      add: true,
                      update: true,
                    },  {
                        field: 'minRechargerAmount',
                        label: '单笔最小充值：',
                        type: 'input',
                        placeholder: '单笔最小充值',
                        rules:[{
                            message: '请输入单笔最小充值', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true
                    }, {
                        field: 'maxRechargerAmount',
                        label: '单笔最大充值：',
                        type: 'input',
                        placeholder: '单笔最大充值',
                        rules:[{
                            message: '请输入单笔最大充值', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true
                    }, {
                      field: 'minWinningAmount',
                      label: '最低奖励：',
                      type: 'input',
                      placeholder: '最低最低奖励',
                      rules:[{
                        message: '请输入最低奖励', trigger: 'blur', required: true
                      }],
                      add: true,
                      update: true
                    }, {
                      field: 'maxWinningAmount',
                      label: '最高奖励：',
                      type: 'input',
                      placeholder: '最高奖励',
                      rules:[{
                        message: '请输入最高奖励', trigger: 'blur', required: true
                      }],
                      add: true,
                      update: true
                    }, {
                      field: 'number',
                      label: '抽奖次数：',
                      type: 'input',
                      placeholder: '抽奖次数',
                      rules:[{
                        message: '请输入抽奖次数', trigger: 'blur', required: true
                      }],
                      add: true,
                      update: true
                    }, {
                      field: 'sort',
                      label: '排序：',
                      type: 'input',
                      placeholder: '排序',
                      rules:[{
                        message: '请输入排序', trigger: 'blur', required: true
                      }],
                      add: true,
                      update: true
                    }]
                }
            }
        },
    }
</script>

<style scoped>

</style>
